import { twMerge } from 'tailwind-merge';
import { ProductCardProps } from '../../types';
import { CheckboxOutline, CheckboxFilled } from '@weee-fe/kunlunicon';
import { useMemo, useState } from 'react';
import { claimCouponLandingProduct } from '@/api/promotion';
import { commonClickExtend } from '@/tracks/useClickActionT2';
import { callAppFunction, isSayWeeeApp } from '@weee-fe/utilities';
import { TargetCouponSubtraction } from '@/types/coupon';
import { formatPersonalizedDiscountCopy } from '../../helper/product-target-coupon';

export default function CardBodyProductClaimed(props: Partial<ProductCardProps>) {
  const { data, className, positionInfoT2 } = props;
  const { claimed = false, extra_attrs = '', copywriting } = data || {};
  const { coupon_type = '', coupon_value = '' } = extra_attrs ? JSON.parse(extra_attrs || '{}') : {};
  const [isClaiming, setIsClaiming] = useState(claimed);

  const subtraction: TargetCouponSubtraction = useMemo(() => {
    return {
      type: coupon_type,
      reduce: coupon_type === 'D' ? Number(coupon_value) : null,
      percentage: coupon_type === 'Z' ? Number(coupon_value) : null
    };
  }, [coupon_type, coupon_value]);

  const desc = useMemo(() => {
    return formatPersonalizedDiscountCopy({ subtraction, claimed: isClaiming, copywriting }, Number(data?.price));
  }, [subtraction, isClaiming, copywriting, data?.price]);

  const handleClick = async (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    e.preventDefault();
    if (isClaiming) return;
    await handleClaim();
    commonClickExtend({
      ...positionInfoT2.modSecPos,
      co: {
        target_nm: coupon_value,
        target_type: `coupon_${coupon_type}`,
        target_pos: positionInfoT2?.prodPos || 0,
        click_type: 'normal',
        is_select: true
      },
      ctx: {
        tag_id: data?.id
      }
    });
  };

  const handleClaim = async () => {
    try {
      const res = await claimCouponLandingProduct({
        product_id: data?.id
      });
      if (res.result) {
        setIsClaiming(prev => !prev);
        /**
         * APP 刷新页面
         */
        if (isSayWeeeApp()) {
          callAppFunction('refreshNativePage');
        }
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  if (copywriting && copywriting.claim_desc) {
    return (
      <div className={twMerge('flex items-center gap-1', className)} onClick={handleClick}>
        <div className={`w-[14px] h-[14px] rounded-sm border flex items-center justify-center enki-body-xs`}>
          {isClaiming ? (
            <CheckboxFilled className="text-tertiary-base-2" />
          ) : (
            <CheckboxOutline className="text-shade-neutral-base-1" />
          )}
        </div>
        <div className="text-tertiary-base-2 enki-body-2xs-medium">{desc}</div>
      </div>
    );
  }

  return null;
}
